import types from './types';

const defaultState = {
  inventory: null,
  initialData: {},
  isLoading: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  let initialData;
  switch (type) {
    case types.GET_INVENTORY_HISTORY:
      return { ...state, inventory: null, isLoading: true };
    case types.GET_INVENTORY_HISTORY_SUCCESS:
      return { ...state, inventory: data, isLoading: false };
    case types.GET_INVENTORY_HISTORY_FAILURE:
      return { ...state, isLoading: false };
    case types.GET_INITIAL_DATA:
      return { ...state, initialData: {}, isLoading: true };
    case types.GET_INITIAL_DATA_SUCCESS:
      return { ...state, initialData: data, isLoading: false };
    case types.GET_INITIAL_DATA_FAILURE:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};
